
export enum DynamicPriceLaneTypeCd {
	BACK_HAUL = 'BackHaul',
	HEAD_HAUL = 'HeadHaul',
	NEUTRAL = 'Neutral'}

